package components

import game.BulletType
import game.ChassisType
import game.GameAction
import game.PowerupType
import game.SkillType
import game.gameStore
import react.FC
import react.ChildrenBuilder
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.p
import web.cssom.ClassName

/**
 * 调试工具面板(开发用):修改金币 / 赠送武器底盘 / 无敌 / 赠送技能道具
 */
val DebugPanel = FC("DebugPanel") {
    val state = useGameState()

    // 开关按钮
    div {
        className = ClassName("debug-toggle")
        onClick = { gameStore.dispatch(GameAction.ToggleDebugPanel) }
        +(if (state.debug.panelOpen) "✕ 关闭调试" else "🛠 调试")
    }

    if (!state.debug.panelOpen) return@FC

    div {
        className = ClassName("debug-panel")

        h2 { +"🛠 调试工具" }

        p { className = ClassName("debug-label"); +"💰 金币" }
        div {
            className = ClassName("debug-row")
            debugBtn("+1000", "gold") { gameStore.dispatch(GameAction.AddCoins(1000)) }
            debugBtn("+10000", "gold") { gameStore.dispatch(GameAction.AddCoins(10000)) }
        }

        p { className = ClassName("debug-label"); +"🛡 无敌" }
        div {
            className = ClassName("debug-row")
            debugBtn(if (state.debug.godMode) "关闭无敌" else "开启无敌", "god") {
                gameStore.dispatch(GameAction.SetGodMode(!state.debug.godMode))
            }
        }

        p { className = ClassName("debug-label"); +"🔫 武器" }
        div {
            className = ClassName("debug-row")
            BulletType.entries.forEach { w ->
                debugBtn(w.name, "weapon") { gameStore.dispatch(GameAction.GrantWeapon(w)) }
            }
        }

        p { className = ClassName("debug-label"); +"🚗 底盘" }
        div {
            className = ClassName("debug-row")
            ChassisType.entries.forEach { c ->
                debugBtn(c.name, "chassis") { gameStore.dispatch(GameAction.GrantChassis(c)) }
            }
        }

        p { className = ClassName("debug-label"); +"⚡ 技能" }
        div {
            className = ClassName("debug-row")
            SkillType.entries.forEach { s ->
                debugBtn(s.name, "skill") { gameStore.dispatch(GameAction.GrantSkill(s)) }
            }
        }

        p { className = ClassName("debug-label"); +"🎁 道具" }
        div {
            className = ClassName("debug-row")
            PowerupType.entries.forEach { t ->
                debugBtn(t.name, "powerup") { gameStore.dispatch(GameAction.GrantPowerup(t)) }
            }
        }

        p { className = ClassName("debug-label"); +"🔢 伤害飘字" }
        div {
            className = ClassName("debug-row")
            debugBtn(if (state.debug.showDamage) "隐藏飘字" else "显示飘字", "toggle") {
                gameStore.dispatch(GameAction.ToggleDamageNumbers(!state.debug.showDamage))
            }
        }
    }
}

// 调试按钮
private fun ChildrenBuilder.debugBtn(
    label: String,
    style: String,
    click: () -> Unit
) {
    button {
        className = ClassName("debug-btn debug-btn-$style")
        onClick = { click() }
        +label
    }
}
